<h2>
	{{ "gateway.download.title" | translate }}
</h2>
<div class="sdp-section-header-description">
	{{ "gateway.download.info.block.1" | translate }}
</div>

<div class="download-section-container">
	<mat-card class="download-section-card">
		<mat-card-content *ngIf="!hasError; else noManifest">
			<div>
				<div>
					<h3 class="download-step-1-heading">1. {{ "gateway.download.step.1.chip" | translate }}</h3>
					<div *ngIf="!!file; else metaLoading">
						<div class="download-file-container">
							<a href="{{ file.url }}">
								<mat-card class="download-file-card">
									<span class="download-file-name">{{ file.name }}</span>
									<span class="download-file-check-sum">MD5 = {{ file.checksum }}</span>
									<sdp-icon [icon]="downloadIcon" class="download-dl-icon"></sdp-icon>
								</mat-card>
							</a>
							<div class="download-whats-new-container">
								<span class="download-version">{{ "gateway.download.version" | translate }}
									{{ file.version }} - </span>
								<a href="{{ changeLogUrl }}"
									target="_blank">{{ "gateway.download.whats.new" | translate }}</a>
							</div>
						</div>
						{{ "gateway.download.step.1" | translate }}
					</div>
					<ng-template #metaLoading>
						<mat-spinner diameter="39"></mat-spinner>
					</ng-template>
				</div>
				<div>
					<h3>2. {{ "gateway.download.step.2.chip" | translate }}</h3>
					<div [innerHTML]="'gateway.download.step.2' | translate | safeHtml"></div>
				</div>
				<div>
					<h3>3. {{ "gateway.download.step.3.chip" | translate }}</h3>
					<div>
						{{ "gateway.download.step.3" | translate }}
					</div>
				</div>
				<div>
					<h3>4. {{ "gateway.download.step.4.chip" | translate }}</h3>
					<div>
						{{ "gateway.download.step.4" | translate }}
						<a class="sdp-link sdp-gateway-activate-link"
							routerLink="/administration/gateways/setup">{{ "gateway.download.step.4.link" | translate }}</a>
					</div>
				</div>
			</div>
		</mat-card-content>
		<ng-template #noManifest>
			<div class="download-noManifest-container">
				{{ "gateway.download.error.noManifest" | translate }}
				<a href="mailto:{{ supportEmail }}">{{ supportEmail }}</a>
			</div>
		</ng-template>
	</mat-card>
</div>